import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { isPresent } from 'helpers/verify';
export var CreditCount = function CreditCount(_ref) {
  var creditsRemaining = _ref.creditsRemaining;
  return isPresent(creditsRemaining) && React.createElement("div", {
    className: "header__credit-count"
  }, React.createElement("a", {
    href: "/settings/membership "
  }, React.createElement(FormattedMessage, {
    id: "nav.mobile.credits",
    defaultMessage: "{creditsRemaining, plural, one {# credit} other {# credits}}",
    values: {
      creditsRemaining: creditsRemaining
    }
  })));
};
CreditCount.propTypes = {
  creditsRemaining: PropTypes.number
};